export function getView(value) {
  if (value === 'TASK_INSERT') {
    return 'Task'
  }
  return 'No'
}
